import { useState, useEffect } from 'react'
import { CourseV5Details } from '../types'

type UseCourseImagesProps = {
  courseDetails: CourseV5Details | null
  isEditMode: boolean
  isLoading: boolean
}

function getImageBasePath(path: string): 'images' | 'public' {
  return path.includes('originals') ? 'images' : 'public'
}

export function useCourseImages({
  courseDetails,
  isEditMode,
  isLoading,
}: UseCourseImagesProps) {
  let [banner, setBanner] = useState<File | undefined>(undefined)
  let [thumbnail, setThumbnail] = useState<File | undefined>(undefined)
  let [existingBannerImage, setExistingBannerImage] = useState<string>('')
  let [existingThumbnailImage, setExistingThumbnailImage] = useState<string>('')
  let [bannerImageBasePath, setBannerImageBasePath] = useState<
    'images' | 'public'
  >('images')
  let [thumbnailImageBasePath, setThumbnailImageBasePath] = useState<
    'images' | 'public'
  >('images')

  useEffect(() => {
    if (isEditMode && courseDetails && !isLoading) {
      setBanner(undefined)
      setThumbnail(undefined)

      let bannerPath = courseDetails.banner ?? ''
      let thumbnailPath = courseDetails.thumbnail ?? ''

      setExistingBannerImage(
        bannerPath ? bannerPath.replace('originals', 'resized') : '',
      )
      setExistingThumbnailImage(
        thumbnailPath ? thumbnailPath.replace('originals', 'resized') : '',
      )
      setBannerImageBasePath(
        bannerPath ? getImageBasePath(bannerPath) : 'images',
      )
      setThumbnailImageBasePath(
        thumbnailPath ? getImageBasePath(thumbnailPath) : 'images',
      )
    } else if (!isEditMode) {
      setBanner(undefined)
      setThumbnail(undefined)
      setExistingBannerImage('')
      setExistingThumbnailImage('')
      setBannerImageBasePath('images')
      setThumbnailImageBasePath('images')
    }
  }, [isEditMode, courseDetails, isLoading])

  return {
    banner,
    setBanner,
    thumbnail,
    setThumbnail,
    existingBannerImage,
    setExistingBannerImage,
    existingThumbnailImage,
    setExistingThumbnailImage,
    bannerImageBasePath,
    thumbnailImageBasePath,
  }
}
